import styled from "styled-components";

export const GoldIconContainer = styled.div`
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.gold};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textInverted};
`;
